<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-12-18 18:25:44
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="page_Container">
    <div class="page">
        <div id="main-container">
            <!-- 发票列表 -->
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh" :class="noData">
                <van-list v-model="ploading" :finished="finished"  @load="onLoad" :offset="1" class="invoice-list">
                    <div class="invoice-item" v-for="item in list" :key="item.merchantOrderNo" @click="invoiceItemClick(item)">
                        <div class="title">商城消费</div>
                        <div class="info">
                            <div class="price">¥{{item.totalAmount}}</div>
                            <div class="type">{{item.depositTypeStr}}</div>
                        </div>
                        <div class="line"></div>
                        <div class="timer">{{item.createTime}}</div>
                        <div class="icon">
                            <img :src="getIcon(item)" alt="">
                        </div>
                    </div>
                    <!-- 无发票 -->
                    <div class="nogood" v-if='!listShow'>
                        <img :src="noListUrl" alt="">
                        <p>暂无发票</p>
                    </div>
                </van-list>
            </van-pull-refresh>

        </div>
    </div>
  </div>
</template>
<script>
// import { toastLoading, clearToastLoading } from '@/utils/base/utils';
// import * as types from '@/store/modules/types';
export default {
    data () {
        return {
            noListUrl: require('../assets/img/myCenter/noList.png'),
            iconImg: {
                wait: require('@/assets/img/myCenter/daikaipiao@3x.png'),
                doing: require('@/assets/img/myCenter/kaipiaozhong@3x.png'),
                already: require('@/assets/img/myCenter/yikaipiao@3x.png')
            },
            list: [],
            loading: false,
            isLoading: false,
            ploading: false,
            finished: true,
            total: 0,
            finishedOk: false,
            pageNum: 1,
            pageSize: 5
        };
    },
    esvReady() {
    },
    esvShow() {
        this.queryOrderInvoiceList();
    },
    methods: {
        invoiceItemClick(item) {
            this.esvOpenPage({ name: 'OPInvoiceDetails', params: { invoiceSerialNumber: item.merchantOrderNo } });
        },
        queryOrderInvoiceList() {
            this.$doRequest(
                {
                    url: '/invoice/queryOrderInvoiceList',
                    params: {},
                    // before() {
                    //     this.loading = toastLoading();
                    // },
                    complete: () => {
                        this.ploading = false;
                        this.isLoading = false;
                        // clearToastLoading(this.loading);
                    }
                }, (data) => {
                    this.list.push(...data.result.list);
                    if (data.result.endRow >= data.result.total) {
                        this.finished = true;
                    } else {
                        this.finished = false;
                    }
                }, (data) => {
                    this.$toast('加载失败');
                    this.list = [];
                }
            );
        },
        getIcon(item) {
            switch (item.invoiceStatus) {
            case 'WAIT':
                return this.iconImg.wait;
            case 'ONGOING':
                return this.iconImg.doing;
            case 'SUCCESS':
                return this.iconImg.already;

            default:
                break;
            }
        },

        onLoad() {
            this.pageNum++;
            this.queryOrderInvoiceList();
        },
        // 下拉刷新
        onRefresh() {
            this.pageNum = 1;
            this.list = [];
            this.queryOrderInvoiceList();
        }
    },
    computed: {
        listShow() {
            return this.list.length > 0;
        },
        noData() {
            return { 'no-data': !this.listShow };
        }
    }
};
</script>
<style lang="scss" scoped>
#page_Container {
    background: #fff;
    #main-container {
        background: #f2f2f2;
        height: 100%;
        .invoice-list {
            padding: 8px 12px;
        }
        .no-data {
            height: 100%;
            /deep/ .van-pull-refresh__track {
                height: 100%;
                .invoice-list {
                    height: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
            }
            // display: flex;
            // height: 100%;
        }
        .invoice-item {
            width: 100%;
            height: 135px;
            background: url('../assets/img/common/CombinedShape@3x.png') no-repeat center;
            background-size: 100% 135px;
            padding: 16px 16px 10px;
            position: relative;
            .icon {
                width: 50px;
                height: 50px;
                position: absolute;
                top: 2px;
                right: 2px;
                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }
            .title {
                font-size: 16px;
                font-weight: 700;
            }
            .info {
                padding: 5px 0;
                display: flex;
                align-items: center;
                .price {
                    font-size: 30px;
                    color: $primary-color;
                }
                .type {
                    font-size: 12px;
                    text-indent: 8px;
                    color: $text-gray-color;
                }

            }
            .line {
                width: 100%;
                height: 1px;
                background-color: $line-color;
            }
            .timer {
                margin-top: 8px;
                text-align: right;
                font-size: 12px;
                color: $text-gray-color;
            }
        }
        .nogood {
            img {
                width:203px;
            }
            p {
                color:#999;
                padding-top:14px;
                text-align:center;
            }
        }
    }
}
</style>
